import PropTypes from "prop-types"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import eyeIcon from "../../../../assets/common/eye.svg"
import eyeHide from "../../../../assets/common/eye-hide.svg"
import searchIcon from "../../../../assets/Hub_Icons/search.svg"
import CustomToolTip from "../../CustomToolTip"

export const InputBox = ({
    id,
    className,
    ariaLabel="",
    name,
    value,
    type,
    label,
    onKeyPressHandler,
    onChangeHandler,
    disabled,
    isRequired,
    errors,
    maxLength,
    minLength,
    pattern,
    dataTestId,
    isglobalTooltip = false,
    customErrorObjName,
    idForToolTip,
    defaultValue,
    wrapperClass,
    onKeyDown,
    placeHolder,
    dataTootipText,
    onSearchClick,
    renderKey,
    minValue,
    maxValue,
    isAvoidSpecialKey = false,
    textHideRequired = false, //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
    onBlurChange,
    isComponentLabelValidation = true, //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
    labelIsRequired = true //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
}) => {
    const isValid = errors && name && errors[name] ? false : true
    const CLASS_NAME =
    className ||
    "w-full p-3 text-sm text-gray-900 rounded-lg" +
      " border border-lightGray appearance-none focus:outline-none" +
      " focus:ring-0 focus:border-primary-100 peer"
    const INPUT_CLASS = isValid
        ? `block disabled:bg-lighestgray h-[38px] focus:outline-none 
        focus:ring-0 focus:border-primary-100 focus:bg-lightSkyblue 
        hover:border-primary-100 transition duration-300 ${CLASS_NAME}`
        : `block disabled:bg-lighestgray border-red h-[38px] 
        focus:outline-none focus:ring-0 focus:border-primary-100 
        focus:bg-lightSkyblue hover:border-primary-100 transition duration-300 ${CLASS_NAME}`
    const ERROR_CLASS ="text-red text-xs font-normal font-['Avenir'] leading-[14px] pt-1"

    const { t } = useTranslation()
    // This is Global fixed
    const exceptThisSymbols = isAvoidSpecialKey ? ["e", "E", ".", "+", "-"] : ["e", "E"]
    const restrictSpecialCharacterInNumber =(e)=>{
        exceptThisSymbols.includes(e.key) && e.preventDefault()
    }
    const [showText,setShowText] = useState(false)
    const [eyeIconEnable,setEyeIconEnable] = useState(eyeIcon)
   
    return (
        <>
            { type === "radio" ? (
                <div className="relative flex gap-1">
                    <input type={ type }
                        id={ id }
                        data-testid={ dataTestId }
                        name={ name }
                        value={ value }
                        checked={ defaultValue }
                        onChange={ onChangeHandler ? onChangeHandler : "" }
                        onKeyPress={ onKeyPressHandler ? onKeyPressHandler : null }
                        className="w-[18px] h-[18px] border border-primary-50 focus:ring-primary-50"
                        tabIndex="0"
                        aria-label = { ariaLabel }
                    />
                    <label htmlFor={ id }                    
                        className="text-sm text-secondary-50 font-normal"
                    >
                        { label }
                    </label>
                </div>
            )  : (
                <>
                    <div className={ `${wrapperClass} relative w-full`  }>
                        <input
                            type={ textHideRequired ? showText ? "text" : "password" :type }
                            id={ id }
                            data-testid={ dataTestId }
                            pattern={ pattern }
                            maxLength={ maxLength || "" }
                            minLength={ minLength || "" }
                            min= { minValue || "" }
                            max={ maxValue || "" }
                            className={ INPUT_CLASS }
                            defaultValue={ defaultValue }
                            placeholder={ type === "search" ? t("search.searchBy") : "" }
                            name={ name }
                            value={ value }
                            disabled={ disabled }
                            onChange={ onChangeHandler ? onChangeHandler : "" }
                            onKeyDown={ type ==="number" ? (e)=>restrictSpecialCharacterInNumber(e) : type ==="search" ? onKeyDown : (e)=>(e)  }
                            key={ renderKey }
                            onBlur = { onBlurChange? onBlurChange : ()=>{} }
                            { ...(isglobalTooltip && {
                                "data-tooltip-id": `tooltip-${idForToolTip}`,
                                "data-tooltip-html": `${ dataTootipText ? dataTootipText : t("common.search") }`
                            }) }
                            aria-label = { ariaLabel || label }
                        />
                        { isglobalTooltip && <CustomToolTip index={ idForToolTip }  isInputBox={ true } position={ "bottom" }/> }
                        { textHideRequired && <button
                            onClick={ (e) => {
                                e.preventDefault()
                                if(value){
                                    setShowText(!showText)
                                    if(showText == false){
                                        setEyeIconEnable(eyeHide)
                                    }
                                    else{
                                        setEyeIconEnable(eyeIcon)
                                    }
                                }
                            } }
                            className="shrink-0 top-2 right-2.5 absolute rounded-full 
                            hover:border-0 hover:bg-primary-150 transition-transform transform hover:scale-110"
                        >
                            <img src={ eyeIconEnable } height="20px" width="20px" alt="Copy" />
                        </button>
                        } 
                        { labelIsRequired && <label
                            htmlFor={ id }
                            className={ `absolute flex text-sm font-normal cursor-text 
                            text-placeHolderColor duration-300 transform -translate-y-[0px] 
                            scale-75 h-[6px] left-[14px] peer-focus:h-[6px] items-center peer-focus:items-center 
                            gap-[0px] peer-focus:gap-[0px] peer-focus:top-[-1.5px] top-[-1.5px] 
                            peer-placeholder-shown:top-[20px] peer-placeholder-shown:-translate-y-1/2 
                            peer-placeholder-shown:scale-100 peer-placeholder-shown:left-[18px] 
                            peer-focus:text-blue-600 peer-focus:scale-75 peer-focus:left-[14px] 
                            bg-white peer-focus:-translate-y-[0px] origin-[0]` }

                        >
                            { isRequired && (
                                <span className="text-red text-sm mr-1 flex">*</span>
                            ) }
                            { label || name }
                        </label> }
                        { type === "search" && <button
                            type="submit"
                            className="absolute right-4 h-9 top-0 flex items-center justify-center"
                            onClick={ onSearchClick }
                        >
                            <img alt="search" src={ searchIcon } className="" height={ "16px" } width={ "16px" } />
                        </button> }
                    </div>
                    <>
                        { isComponentLabelValidation && errors && name && errors[name] && (
                            (errors[name] === "TagsNotAllowed") ? <span className={ ERROR_CLASS }>
                                { t("errorMessage.tagsNotAllowed") }
                            </span>
                                : <span className={ ERROR_CLASS }>
                                    { customErrorObjName
                                        ? t(`errorMessage.${customErrorObjName}.${name}`)
                                        : name.includes("emailItem") ? "Please Enter Valid email" : t(`errorMessage.${name}`) }
                                </span>
                        ) }
                    </>
                </>
            ) }
        </>
    )
}

InputBox.propTypes = {
    className: PropTypes.string,
    customErrorObjName: PropTypes.string,
    defaultValue: PropTypes.any,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    id: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    maxLength: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChangeHandler: PropTypes.func,
    pattern: PropTypes.string,
    type: PropTypes.string.isRequired,
    value: PropTypes.string,
    wrapperClass: PropTypes.string
}